import { connect } from "react-redux";
import React, { Component } from "react";
import ProviderInfo from "./profileInfo";
import { moduleAction, getNumberApprovals } from "../../../utils/functions";
import { getRoles } from "../../../../Redux/reducer/session";
import { getModules } from "../../../../Redux/reducer/clients";
import ManualProvider from "../../../shared/provider/manualProvider";
import { MOD_DISCONT_PROV, MOD_PROVID, WRITE } from "../../../../permissions";
import { getAuthenticatedClientModules } from "../../../../Redux/actions/clientActions";

export class ProviderProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provider: this.getDefaulttProvider(props.provider),
      chage: false,
      needToken: false,
    };
  }

  componentDidMount() {
    this.props.getModules();
  }

  changeInfo = () => {
    var approvals = getNumberApprovals(this.props.clientModules, MOD_PROVID);
    const approvalsDiscount = getNumberApprovals(
      this.props.clientModules,
      MOD_DISCONT_PROV
    );

    if (
      approvals <= 0 ||
      (this.state.provider.provider.toBillDiscount && approvalsDiscount === 0)
    ) {
      this.setState({ needToken: true });
    }
    this.setState((prevState) => ({ change: !prevState.change }));
  };

  getDefaulttProvider = (provider) => {
    if (
      provider.provider.accounts === null ||
      provider.provider.accounts.length <= 0
    ) {
      provider.provider.accounts = [];
      provider.provider.accounts.push({
        accountCurrency: "",
        accountIntermediaryBank: "",
        accountNumber: "",
        accountType: "",
        bicDestinationBank: "",
        bicIntermediaryBank: "",
        iban: true,
      });
    }
    return provider;
  };

  render() {
    const { provider, change, needToken } = this.state;
    const canEdit = moduleAction(this.props.roles, MOD_PROVID, WRITE);

    return !change ? (
      <ProviderInfo
        provider={provider}
        changeInfo={() => this.changeInfo()}
        canEdit={canEdit}
      />
    ) : (
      <ManualProvider
        needToken={needToken}
        provider={provider}
        submitUrl={"providers"}
        submitMethod={"put"}
      />
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    roles: getRoles(state),
    clientModules: getModules(state),
  };
};

export const mapDispatch = (dispatch) => ({
  getModules: () => dispatch(getAuthenticatedClientModules()),
});

export default connect(mapStateToProps, mapDispatch)(ProviderProfile);
